const FALLBACK_TOP = 56;

export default function stickyTableHeader() {
    return {
        resizeObserver: null,
        headerObserver: null,
        offMorphed: null,
        onContainerScroll: null,

        init() {
            this.$nextTick(() => this.syncStickyHeader());

            this.resizeObserver = new ResizeObserver(() => {
                requestAnimationFrame(() => this.syncStickyHeader());
            });

            this.resizeObserver.observe(this.$refs.container);

            this.offMorphed = window.Livewire?.hook('morphed', () => {
                if (!this.$el.isConnected) {
                    this.teardown();

                    return;
                }

                requestAnimationFrame(() => this.syncStickyHeader());
            });

            this.onContainerScroll = () => {
                this.$refs.stickyHeader.scrollLeft = this.$refs.container.scrollLeft;
            };

            this.$refs.container.addEventListener('scroll', this.onContainerScroll);

            this.syncStickyTop();
        },

        destroy() {
            this.teardown();
        },

        teardown() {
            this.resizeObserver?.disconnect();
            this.headerObserver?.disconnect();
            this.offMorphed?.();

            if (this.onContainerScroll) {
                this.$refs.container?.removeEventListener('scroll', this.onContainerScroll);
            }
        },

        syncStickyTop() {
            const appHeader = document.getElementById('app-header');

            if (!appHeader) {
                this.$refs.stickyHeader.style.top = `${FALLBACK_TOP}px`;

                return;
            }

            const updateStickyTop = () => {
                this.$refs.stickyHeader.style.top = `${appHeader.offsetHeight}px`;
            };

            updateStickyTop();

            this.headerObserver = new ResizeObserver(updateStickyTop);
            this.headerObserver.observe(appHeader);
        },

        syncStickyHeader() {
            const container = this.$refs.container;
            const host = this.$refs.stickyHeader;
            const source = container?.querySelector('thead');

            if (!container || !host || !source) {
                return;
            }

            const originTable = source.closest('table');

            this.collapse(source);

            const clone = source.cloneNode(true);

            this.restore(clone);
            this.applyColumnWidths(clone, source, originTable);

            const table = document.createElement('table');

            table.className = originTable ? originTable.className : 'min-w-full';
            table.style.width = `${originTable?.scrollWidth ?? container.scrollWidth}px`;
            table.appendChild(clone);

            host.innerHTML = '';
            host.appendChild(table);
            host.scrollLeft = container.scrollLeft;
        },

        collapse(source) {
            source.style.visibility = 'collapse';
            source.style.height = '0';
            source.style.overflow = 'hidden';

            source.querySelectorAll('tr').forEach((tr) => {
                tr.style.height = '0';
            });

            source.querySelectorAll('th').forEach((th) => {
                th.style.height = '0';
                th.style.paddingTop = '0';
                th.style.paddingBottom = '0';
                th.style.borderTopWidth = '0';
                th.style.borderBottomWidth = '0';
            });
        },

        restore(clone) {
            clone.style.visibility = 'visible';
            clone.style.height = '';
            clone.style.overflow = '';

            clone.querySelectorAll('tr').forEach((tr) => {
                tr.style.height = '';
            });

            clone.querySelectorAll('th').forEach((th) => {
                th.style.height = '';
                th.style.paddingTop = '';
                th.style.paddingBottom = '';
                th.style.borderTopWidth = '';
                th.style.borderBottomWidth = '';
            });
        },

        applyColumnWidths(clone, source, originTable) {
            const originalThs = source.querySelectorAll('th');
            const firstRowTds = originTable?.querySelectorAll('tbody > tr:first-child > td') ?? [];

            clone.querySelectorAll('th').forEach((th, index) => {
                const reference = firstRowTds[index] ?? originalThs[index];

                if (!reference) {
                    return;
                }

                const width = reference.getBoundingClientRect().width;

                if (width === 0) {
                    return;
                }

                th.style.width = `${width}px`;
                th.style.minWidth = `${width}px`;
                th.style.maxWidth = `${width}px`;
            });
        },
    };
}
